import useAuth from './useAuth';

// True only for admin / super-admin.
//
// The scoped staff roles (customer-care, sales, sales-manager, support) can
// create and edit on the surfaces they own, but DELETE on the marketing-content
// modules stayed admin-only on the backend. Pages that show a delete control to
// everyone therefore render a button that always 403s — use this to hide it.
//
// Diplomas and Programs are the deliberate exception: customer-care was granted
// delete on those two, so their pages must NOT gate on this.
export default function useIsFullAdmin(): boolean {
  const { user } = useAuth();
  const roles: string[] = ((user as any)?.roles as string[]) ?? [];
  return roles.includes('admin') || roles.includes('super-admin');
}
